import { Link } from 'react-router-dom';

interface ClusterCard {
  title: string;
  description: string;
  to?: string;
  available: boolean;
}

const cards: ClusterCard[] = [
  {
    title: 'Менеджмент и лидерство',
    description: 'Хаб направления: все темы развития управленческих компетенций руководителей.',
    to: '/menedzhment-i-liderstvo',
    available: true,
  },
  {
    title: 'Тренинг для руководителей',
    description: 'Комплексная программа развития управленческих компетенций для руководителей всех уровней.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
    available: true,
  },
  {
    title: 'Делегирование и постановка задач',
    description: 'Как передавать ответственность сотрудникам и управлять результатом без микроменеджмента.',
    to: '/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach',
    available: true,
  },
  {
    title: 'Обратная связь и сложные разговоры',
    description: 'Как давать обратную связь, которая меняет поведение, и проводить сложные разговоры.',
    to: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory',
    available: true,
  },
  {
    title: 'Мотивация и управление командой',
    description: 'Как понимать мотивацию сотрудников и создавать условия для вовлечённости и результативности.',
    to: '/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy',
    available: true,
  },
  {
    title: 'Управление конфликтами',
    description: 'Как разбирать конфликты в команде и превращать их в рабочие решения.',
    to: '/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami',
    available: true,
  },
  {
    title: 'Управление изменениями',
    description: 'Как внедрять изменения и работать с сопротивлением команды.',
    to: '/menedzhment-i-liderstvo/upravlenie-izmeneniyami',
    available: true,
  },
  {
    title: 'Руководитель в переговорах',
    description: 'Как руководителю влиять, договариваться и отстаивать интересы бизнеса в ключевых переговорах.',
    to: '/menedzhment-i-liderstvo/rukovoditel-v-peregovorah',
    available: true,
  },
  {
    title: 'Развитие управленческих компетенций',
    description: 'Комплексная оценка и развитие ключевых управленческих навыков руководителей.',
    to: '/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy',
    available: true,
  },
  {
    title: 'Наставничество и развитие сотрудников',
    description: 'Как передавать опыт, развивать самостоятельность команды и формировать кадровый резерв.',
    to: '/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov',
    available: true,
  },
];

export default function ClusterLinksSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Менеджмент и лидерство
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Управленческие переговоры не существуют отдельно от других управленческих компетенций. Они работают в связке с постановкой задач, обратной связью, мотивацией и управлением конфликтами. Поэтому внутри кластера есть специализированные направления.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className={`bg-gray-50 rounded-xl border ${card.available ? 'border-gray-200 hover:border-teal-300' : 'border-gray-200/70'} transition-all p-5 md:p-6 flex flex-col`}
            >
              <h3 className="text-base font-bold text-gray-900 mb-2">{card.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">{card.description}</p>
              {card.available && card.to ? (
                <Link
                  to={card.to}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-auto"
                >
                  Подробнее
                  <i className="ri-arrow-right-line"></i>
                </Link>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-sm text-gray-400 mt-auto">
                  Скоро
                  <i className="ri-time-line"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}